import React, { Children, Fragment, ReactNode } from "react";

interface JoinProps {
    children: ReactNode;
    separator: ReactNode;
}

/**
 * Similar to `Array.join` but for React components
 */
export const Join = ({ children, separator }: JoinProps) => {
    return (
        <>
            {Children.map(children, (child, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Fragment key={index}>
                    {index > 0 && separator}
                    {child}
                </Fragment>
            ))}
        </>
    );
};
